import type { IOffer } from "@bbj-types/offer";
import { CreateWithAIModal, type ICreateWithAIModalLabels } from "@complex/CreateWithAIModal";
// TODO: remplacer par le vrai schéma FormGen candidature
import { formSchema } from "@complex/FormGen";
import { OfferKind } from "@root/utils/enums/offer";
import { useAIGeneration } from "./logics";

/**
 * Une candidature se rattache à une offre : l'IA extrait donc l'offre du texte collé, et ces
 * données pré-remplissent le formulaire de candidature. D'où la même route que côté offre.
 */
export type TApplyFromAI = Partial<IOffer>;

const LABELS: ICreateWithAIModalLabels = {
  title: "Importer du texte pour générer la candidature via IA",
  instruction:
    "Copier coller le texte de la candidature dans l'encart ci-dessous puis cliquer sur « Afficher la/ les candidatures générées » pour remplir automatiquement les champs.",
  generate: "Afficher la/les candidatures générées",
  confirm: "Créer les candidatures",
  items: "Candidatures générées",
  generating: "Candidature(s) en cours de génération",
  empty: "Aucune candidature n'a été détectée dans ce texte.",
  failed: (failedCount, total) => `Échec de génération pour ${failedCount} candidature(s) sur ${total}.`,
};

export interface IModalApplyFromAIProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (items: TApplyFromAI[]) => void;
}

export const ModalApplyFromAI = ({ open, onClose, onConfirm }: IModalApplyFromAIProps) => {
  const { generation, handleGenerate, reset } = useAIGeneration<TApplyFromAI>(OfferKind.JOB);

  const handleClose = () => {
    reset();
    onClose();
  };

  return (
    <CreateWithAIModal
      open={open}
      labels={LABELS}
      generation={generation}
      schema={formSchema}
      onClose={handleClose}
      onGenerate={handleGenerate}
      onConfirm={(candidates) => {
        onConfirm(candidates);
        handleClose();
      }}
    />
  );
};
